import { render, staticRenderFns } from "./myConsultationDetail.vue?vue&type=template&id=40df0044&scoped=true&"
import script from "./myConsultationDetail.vue?vue&type=script&lang=js&"
export * from "./myConsultationDetail.vue?vue&type=script&lang=js&"
import style0 from "./myConsultationDetail.vue?vue&type=style&index=0&id=40df0044&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df0044",
  null
  
)

export default component.exports